import React, { Component } from 'react';
import axios from '../../axios';
import qs from 'qs';
import Alert from 'react-s-alert'
import FormDropdown from '../../components/FormDropdown'
import { status_aktif } from '../../constants/general'
import { convertAngkaKeHari } from '../../functions/functionGeneral'
import TimePicker from 'rc-time-picker'
import moment from 'moment'
import { semester } from '../../constants/tahunAjar'

const dataHari = []

for (let i=0; i<7; i++) {
    dataHari[i] = {
        key     : i + 1,
        value   : convertAngkaKeHari(i + 1)
    }
}

class Forms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            jadwal_id               : "",
            kelas_id                : "",
            mapel_id                : "",
            user_id                 : "",
            jadwal_hari             : "",
            jadwal_mulai            : "",
            jadwal_mulai_moment     : "",
            jadwal_selesai          : "",
            jadwal_selesai_moment   : "",
            jadwal_semester         : "",
            jadwal_lokasi           : "",
            jadwal_status           : "",
            dataKelas               : [],
            dataGuru                : [],
            dataMapel               : [],
            isButtonLoading         : false,
            isLoading               : false,
        }

        this.handleChange       = this.handleChange.bind(this);
        this.handleSubmit       = this.handleSubmit.bind(this);
        this.handleTimePicker   = this.handleTimePicker.bind(this);
    }

    handleChange(event) {
        
        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })        
    }

    handleSubmit() {

        let formData = new FormData();

        const config = {
            headers: { "content-type": "multipart/form-data" }
        };
        formData.append("kelas_id", this.state.kelas_id);
        formData.append("jadwal_id", this.state.jadwal_id);
        formData.append("mapel_id", this.state.mapel_id);
        formData.append("user_id", this.state.user_id);
        formData.append("jadwal_hari", this.state.jadwal_hari);
        formData.append("jadwal_mulai", this.state.jadwal_mulai);
        formData.append("jadwal_mulai_moment", this.state.jadwal_mulai_moment);
        formData.append("jadwal_selesai", this.state.jadwal_selesai);
        formData.append("jadwal_selesai_moment", this.state.jadwal_selesai_moment);
        formData.append("jadwal_semester", this.state.jadwal_semester);
        formData.append("jadwal_lokasi", this.state.jadwal_lokasi);
        formData.append("jadwal_status", this.state.jadwal_status);
        formData.append("dataKelas", this.state.dataKelas);
        formData.append("dataGuru", this.state.dataGuru);
        formData.append("dataMapel", this.state.dataMapel);

        const url = this.props.mode === "Tambah" ? "jadwal/add" : "jadwal/edit"
        this.setState({isButtonLoading: true})


        axios.post(url, formData, config)
            .then(response => {

                const result = response.data;

                if (result.success) {
                    Alert.success(result.message);
                    this.props.history.replace("/jadwal");
                } else {
                    if (Array.isArray(result.message)) {
                        result.message.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.message);
                    }

                    this.setState({ isButtonLoading: false });
                }
            })
            .catch(error => {
                console.log("ERROR", error);
                Alert.error("Gagal terhubung ke server!");
                this.setState({ isButtonLoading: false });
            });

    }

    handleTimePicker(momentValue, stateName, stateMomentName) {
        
        const newState = {}

        newState[stateName]       = momentValue.format("HH:mm:ss")
        newState[stateMomentName] = momentValue

        this.setState(newState)
    }

    loadDataKelas() {

        axios.post("/kelas")
            .then(response => {

                return response.data.data.map(item => ({
                    key: item.kelas_id,
                    value: item.kelas_nama
                }))
            })
            .then(result => {

                this.setState({
                    dataKelas: result
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    loadDataGuru() {

        const params = qs.stringify({
            level: "guru"
        })

        axios.post("/user?" + params)
            .then(response => {

                return response.data.data.map(item => ({
                    key   : item.user_id,
                    value : item.user_nama
                }))
            })
            .then(result => {

                this.setState({
                    dataGuru: result
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    loadDataMapel() {

        axios.post("/mapel")
            .then(response => {

                return response.data.mapelexport.map(item => ({
                    key   : item.mapel_id,
                    value : item.mapel_nama
                }))
            })
            .then(result => {

                this.setState({
                    dataMapel: result
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    loadData() {

        if (this.props.mode === "Edit") {  
            
            this.setState({ isLoading: true })
            console.log(this.props.match.params.jadwal_id)
            axios({
                method: 'get',
                url: '/jadwal/' + this.props.match.params.jadwal_id
            })
                .then(response => {

                    const result = response.data

                    if (result.success) {

                        this.setState({
                            jadwal_id               : result.data.jadwal_id,
                            kelas_id                : result.data.kelas_id,
                            mapel_id                : result.data.mapel_id,
                            user_id                 : result.data.user_id,
                            jadwal_hari             : result.data.jadwal_hari,
                            jadwal_mulai            : result.data.jadwal_mulai,
                            jadwal_mulai_moment     : moment(result.data.jadwal_mulai, "HH:mm:ss"),
                            jadwal_selesai          : result.data.jadwal_selesai,
                            jadwal_selesai_moment   : moment(result.data.jadwal_selesai, "HH:mm:ss"),
                            jadwal_semester         : result.data.jadwal_semester,
                            jadwal_lokasi           : result.data.jadwal_lokasi,
                            jadwal_status           : result.data.jadwal_status,                                                    
                        })
                    }   
                    else {

                        Alert.error(result.message)
                    }                    

                    this.setState({ isLoading: false })
                    console.log(response)
                })
                .catch((error) => {

                    console.log(error)
                    Alert.error("Gagal terhubung ke server!")
                    this.setState({ isLoading: false })
                })
        }
        
    }

    componentDidMount() {

        this.loadData()
        this.loadDataKelas()
        this.loadDataMapel()
        this.loadDataGuru()
    }
    
    render() {
        
        return (
            <div className="col-sm-12">                
                <div className="card">
                    <div className="card-header">
                        {this.props.mode} Mata Pelajaran
                    </div>
                    <div className="card-block">
                    {
                        this.state.isLoading ? 'Memuat Data...' : (
                            <div className="form-horizontal animated fadeIn">
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Kelas</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={this.state.dataKelas}
                                            onChange={this.handleChange}
                                            value={this.state.kelas_id}
                                            name="kelas_id"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Mata Pelajaran</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={this.state.dataMapel}
                                            onChange={this.handleChange}
                                            value={this.state.mapel_id}
                                            name="mapel_id"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Guru</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={this.state.dataGuru}
                                            onChange={this.handleChange}
                                            value={this.state.user_id}
                                            name="user_id"
                                          />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Hari</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={dataHari}
                                            onChange={this.handleChange}
                                            value={this.state.jadwal_hari}
                                            name="jadwal_hari"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Jam Mulai</label>
                                    <div className="col-md-10">                                       
                                        <TimePicker
                                            name="jadwal_mulai"
                                            value={this.state.jadwal_mulai_moment}
                                            onChange={(value) => {
                                                this.handleTimePicker(value, "jadwal_mulai", "jadwal_mulai_moment")
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Jam Berakhir</label>
                                    <div className="col-md-10">                                        
                                        <TimePicker
                                            name="jadwal_selesai"
                                            value={this.state.jadwal_selesai_moment}
                                            onChange={(value) => {
                                                this.handleTimePicker(value, "jadwal_selesai", "jadwal_selesai_moment")
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Semester</label>
                                    <div className="col-md-10">     
                                        <FormDropdown
                                            items={semester}
                                            onChange={this.handleChange}
                                            value={this.state.jadwal_semester}
                                            name="jadwal_semester"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Lokasi</label>
                                    <div className="col-md-10">
                                        <input
                                            name="jadwal_lokasi"
                                            type="text"
                                            className="form-control"
                                            onChange={this.handleChange}
                                            value={this.state.jadwal_lokasi} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Status Aktif</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={status_aktif}
                                            onChange={this.handleChange}
                                            value={this.state.jadwal_status}
                                            name="jadwal_status"
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    }                    
                    </div>
                    <div className="card-footer">
                        <button 
                            type="button" 
                            className="btn btn-md btn-primary"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={this.handleSubmit}
                        >
                            {this.state.isButtonLoading ? "Loading" : "Simpan"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Forms;


// WEBPACK FOOTER //
// ./src/views/Jadwal/Forms.js